import React from "react";
import { Col, Row } from "react-bootstrap";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { actions as debinActions } from "reducers/debin";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import { useTransaction } from "hooks/useTransactions";
import Image from "pages/_components/Image";
import gaEventTracker, { events } from "util/gaEventTracker";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";

const ActionsTransactionPage = (props) => {
    let title;
    const formatTransaction = (data, idTransaction) => {
        const formData = {
            ...data,
            idTransaction,
            debin: {
                id: data.id,
                debin: {
                    lending: data.prestacion,
                    reference: data.referencia,
                    detail: data.detalle,
                    concept: data.concepto,
                    currency: data.moneda,
                },
                buyer: {
                    cbu: data.cbu,
                },
                sellerName: data.sellerName,
                sellerCuit: data.seller,
            },
        };
        return { ...formData };
    };

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/debinPayments/action/action",
        debinActions.setRecurrencyDebinAction,
        debinActions.cleanDebinTicket,
        formatTransaction,
    );

    if (transaction?.data?.action === "PAUSAR") {
        title = "debin.pause";
    }
    if (transaction?.data?.action === "ELIMINAR") {
        title = "debin.eliminate";
    }
    if (transaction?.data?.action === "ACTIVAR") {
        title = "debin.activate";
    }
    const { data = {} } = transaction;
    const { sellerName, seller, id: idTransaction, account, prestacion, referencia, concepto, detalle } = data;
    const debitAccountMask = account?.shortLabel ? `****${account?.shortLabel?.substring(1)}` : "";

    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(title, id, "debin.actions");
    const { isFinished, isBackoffice } = status;
    const { isDesktop } = props;
    // const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleDownload = async () => {
        // await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.pagos_servicios_descargar());
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="debin.actions" />
            {!isBackoffice && <ResponsiveHeader noBack ticket metaTitle={title} />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title={title} {...props} />
                            <GridTable className="form-summary">
                                <GridTable.Container columns={3} rows={4}>
                                    <GridTable.Data flexDirection="column">
                                        <CustomData
                                            titleText="debin.id.recurency"
                                            titleTextType="I18N"
                                            valueText={idTransaction}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data flexDirection="column" columnStart={2} rowStart={1}>
                                        <CustomData
                                            titleText="debin.dateExpitation"
                                            titleTextType="I18N"
                                            valueText={debitAccountMask}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data flexDirection="column" columnStart={3} rowStart={1}>
                                        <CustomData
                                            titleText="debin.seller"
                                            titleTextType="I18N"
                                            valueText={sellerName}
                                            valueTextType="TEXT"
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data flexDirection="column" columnStart={1} rowStart={2}>
                                        <CustomData
                                            titleText="debin.seller.cuit"
                                            titleTextType="I18N"
                                            valueText={seller}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                                <GridTable.Container columns={3} rows={2}>
                                    <GridTable.Data flexDirection="column">
                                        <CustomData
                                            titleText="debin.service.label"
                                            titleTextType="I18N"
                                            valueText={prestacion}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data flexDirection="column">
                                        <CustomData
                                            titleText="debin.reference"
                                            titleTextType="I18N"
                                            valueText={referencia}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data flexDirection="column">
                                        <CustomData
                                            titleText="debin.concept.label"
                                            titleTextType="I18N"
                                            valueText={concepto}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data flexDirection="column">
                                        <CustomData
                                            titleText="debin.description.label"
                                            titleTextType="I18N"
                                            valueText={detalle}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                                {isFinished && (
                                    <GridTable.Container>
                                        <GridTable.Data columnStart={1} columnWidth="3">
                                            <div className="horizontal-divider" />
                                        </GridTable.Data>
                                        <GridTable.Data columnStart={2} columnWidth="3">
                                            <div className="text-center">
                                                <Image src="images/figma/illustrations/rapipago.svg" />
                                            </div>
                                        </GridTable.Data>
                                    </GridTable.Container>
                                )}
                            </GridTable>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            {!isFinished && (
                                <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                    <Button
                                        onClick={() => dispatch(push("/desktop"))}
                                        label="forms.transaction.ticket.actions.backToHome"
                                        className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                    />
                                </Col>
                            )}
                            {isFinished && (
                                <>
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <Button
                                            image="images/download.svg"
                                            onClick={handleDownload}
                                            label="global.download"
                                            className="btn  btn-outline"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4} mdOffset={2}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={() => dispatch(push("/desktop"))}
                                            label="forms.transaction.ticket.actions.backToHome"
                                            className="btn btn-primary"
                                        />
                                    </Col>
                                </>
                            )}
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

ActionsTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ActionsTransactionPage;
